import api from '../config/api';
import {
  FETCH_RESERVATION_LOADING,
  FETCH_RESERVATION_SUCCESS,
  FETCH_RESERVATION_ERROR
} from '../Types/thirdPartySiteTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchClientSiteRequests = (start, end, page, limit) => {
  return dispatch => {
    dispatch({ type: FETCH_RESERVATION_LOADING });

    const query = new URLSearchParams();
    if (page && limit) {
      query.append('page', page);
      query.append('limit', limit);
    }

    api
      .get(`${API_URL}Request/getThirdPartyRequests/${start}/${end}?${query.toString()}`)
      .then(response => {
        const { data, pagination } = response.data;
        dispatch({
          type: FETCH_RESERVATION_SUCCESS,
          payload: { data, pagination }
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_RESERVATION_ERROR,
          payload: errorMsg
        });
      });
  };
};
